import * as React from "react";
import { InputHTMLAttributes, ReactNode, useMemo } from "react";
import { Field } from 'redux-form'
import IFormInputs from "./IFormInputs";
import { FormattedMessage } from "react-intl";
import InputRenderer from "../formrenderers/InputRenderer";
import Required from "../validations/Required";

const PhoneNumberValidation: (value: any) => ReactNode | undefined =
    (value) => {
        return value && !/^([0-9]{10})$/i.test(value)
            ? <FormattedMessage id="form.validations.phone_no.invalid" />
            : undefined;
    };

export interface IPhoneNoInputProps extends IFormInputs, InputHTMLAttributes<HTMLInputElement> {
    isRequired?: boolean;
    mobileLockMobileNumber?: string;
}

export default (props: IPhoneNoInputProps) => {
    const { inputID, label = <FormattedMessage id="form.phone_no" />,
        validationDisabled = false,
        isRequired = true,
        mobileLockMobileNumber,
        ...rest
    } = props;


    const validations = useMemo(() => {
        if(validationDisabled) {
            return undefined;
        }

        const validations = [PhoneNumberValidation];
        if(isRequired) {
            validations.push(Required);
        }

        if(mobileLockMobileNumber) {
            validations.push((phoneNumber) => {
                if(`1${phoneNumber}` !== mobileLockMobileNumber) {
                    return <FormattedMessage id="form.validations.phone_no.does_not_match" />;
                }
                return undefined;
            })
        }

        return validations;
    }, [validationDisabled, isRequired, mobileLockMobileNumber]);

    return (
        <Field name={inputID} label={label} type="text" component={InputRenderer} validate={validations} {...rest} />
    );
}